// src/components/home/CTABanner/CTABanner.jsx
import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiPhoneCall } from "react-icons/fi";
import "./CTABanner.css";
import visit from "../../utils/visit";

export default function CTABanner() {
  return (
    <section className="ctaB">
      <div className="container">
        <motion.div
          className="ctaB__wrap"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="ctaB__left">
            <span className="ctaB__kicker">Ready when you are</span>
            <h2 className="ctaB__title">Ready to Find Your Next Property?</h2>
            <p className="ctaB__sub">
              Talk to our experts or schedule a visit—no pressure, just clear
              guidance and the right options.
            </p>

            <div className="ctaB__points">
              <span className="ctaB__point">Verified listings</span>
              <span className="ctaB__dot" />
              <span className="ctaB__point">Transparent process</span>
              <span className="ctaB__dot" />
              <span className="ctaB__point">Fast scheduling</span>
            </div>
          </div>

          <div className="ctaB__right">
            <a href={visit()} target="_blank">
              <button className="ctaB__btn ctaB__btn--primary" type="button">
                Book a Visit <FiArrowUpRight />
              </button>
            </a>
            <a href={visit()} target="_blank">
              <button  className="ctaB__btn ctaB__btn--ghost" type="button">
                Call Now <FiPhoneCall />
              </button>
            </a>

            <div className="ctaB__hint">
              Response time: <strong>usually within 15 minutes</strong>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
